<template>
  <!-- Main Content -->
  <div id="content">
    <!-- Begin Page Content -->
    <div class="container-fluid">
      <!-- Page Heading -->
      <h1 class="h3 mb-2 text-gray-800">Usuarios</h1>
      <!-- DataTales Example -->
      <div class="card shadow mb-4">
        <div class="row">
          <div class="col-md-6">
            <div>
              <form
                class="d-none d-sm-inline-block form-inline mr-auto ml-md-4 my-2 my-md-0 mw-100 navbar-search">
                <div class="input-group">
                  <input type="text" class="form-control bg-light border-0 small" placeholder="Buscar Usuario"
                         aria-label="Search" aria-describedby="basic-addon2" v-on:keyup.enter="loadUsers" v-model="search">
                  <div class="input-group-append">
                    <button class="btn btn-primary" type="button" @click="loadUsers">
                      <font-awesome-icon icon="search" />
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>

        </div>
        <div class="card-body">
          <div class="table-responsive">
            <b-table striped hover :items="usersItems" :fields="fields">
              <template #cell(provider)="data">
                <span>{{data.item.provider}}</span>
              </template>
              <template #cell(deleted)="data">
                <span v-if="data.item.deleted">Sí</span>
                <span v-else>No</span>
              </template>

              <template #cell(roles)="data">
                 <p> {{getRoles(data.item.roles) }}</p>
              </template>
              <!-- A virtual column -->
              <template #cell(actions)="data">
                <b-dropdown v-if="userPermission === 'ROLE_ADMIN'" id="dropdown-1" text="Acciones" class="m-md-1" >
                  <b-dropdown-item><router-link :to="{ name: 'UsersEdit', params: { id: data.item.id}}" >
                    <font-awesome-icon icon="fas fa-edit" />&nbsp;Editar
                  </router-link></b-dropdown-item>
                  <b-dropdown-item  v-if="(!data.item.deleted || data.item.deleted == false) && data.item.id !== userId" @click="deleteUser(data.item.id)">
                    <a href="#"><font-awesome-icon icon="fas fa-trash" />&nbsp;Eliminar</a>
                  </b-dropdown-item>
                  <b-dropdown-item  v-if="data.item.deleted == true && data.item.id !== userId" @click="deleteUser(data.item.id)">
                    <a href="#"><font-awesome-icon icon="fas fa-check-to-slot" />&nbsp;Activar</a>
                  </b-dropdown-item>
                </b-dropdown>
              </template>
            </b-table>

            <b-pagination
              v-model="currentPage"
              :total-rows="rows"
              :per-page="perPage"
              aria-controls="my-table"

            ></b-pagination>
          </div>
        </div>
      </div>

    </div>

  </div>
</template>

<script>
import axios from "axios";
import { AUTHORITIES } from "../../../../Utils/constants/global.constants";

export default {
  name: "UsersAdmin",
  data: () => {
    return {
      userId: null,
      userPermission: '',
      fields: [
        {
          key: 'name',
          sortable: true,
          label: "Nombre"
        },
        {
          key: 'email',
          sortable: true,
          label: "Email"
        },
        {
          key: 'provider',
          label: 'Tipo Usuario',
          sortable: true,
        },
        {
          key: 'roles',
          sortable: true,
          label: "Rol"
        },
        {
          key: 'deleted',
          label: 'Eliminado',
          sortable: false,
        },
        {
          key: 'actions',
          label: '',
          sortable: true,
        }
      ],
      search: '',
      usersItems: [],
      currentPage: 1,
      rows: 10,
      perPage: 10,
    }
  },
  methods: {
    getRoles(rol) {
      if (rol.length > 0) {
        return AUTHORITIES[rol[0].name];
      } else return '';
    },
    deleteUser(id) {
      if(!confirm("¿Estás seguro que deseas eliminar este usuario? Esta acción es irreversible")){
      return
    }
      let loader = this.$loading.show({});
      axios
        .delete(
          import.meta.env.VITE_API_BASE_URL + "/user/" + id,
          {
            headers: {
              Authorization: "Bearer " + localStorage.getItem("token"),
            },
          }
        )
        .then((response) => {
          console.log(response);
          this.loadUsers()
          loader.hide();
        })
        .catch((err) => {
          console.log(err.message);
          loader.hide();
        });
    },
    loadUsers () {
      let loader = this.$loading.show({});
      axios
        .get(
          import.meta.env.VITE_API_BASE_URL + "/user/",
          {
            params: { page: this.currentPage, size: this.perPage, sort: 'DESC', search:  this.search },
            headers: {
              Authorization: "Bearer " + localStorage.getItem("token"),
            },
          }
        )
        .then((response) => {
          loader.hide();
          console.log(response)
          this.usersItems = response.data.content;
          this.rows = response.data.totalElements
        })
        .catch((err) => {
          console.log(err.message);
          loader.hide();
        });
    }
  },
  watch: {
    currentPage: function () {
      this.loadUsers()
    }
  },
  mounted() {
    this.loadUsers();
    this.userPermission =  localStorage.getItem("role");
  },
  beforeMount() {
    let auth = JSON.parse(window.localStorage.getItem("auth"));
    this.userId = auth.data.id;
  }
};
</script>

<style scoped>

</style>
